// extracted by mini-css-extract-plugin
module.exports = {"container":"RefundDetailDrawer_container__ft2Tz","tips":"RefundDetailDrawer_tips__1okR5"};